<template>
  <modal :center="false" :show="visible" modalClasses="modal-xxl">
    <b-row class="sticky-top pt-2 bg-light mt--3 mb-2">
      <b-col sm="12" md="4">
        <b-button class="mb-2" block variant="secondary" @click="handleClose">
          Đóng (Esc)
        </b-button>
      </b-col>
      <b-col sm="12" md="4">
        <b-button block variant="info" @click="doPrint"> <i class="fa fa-print" aria-hidden="true"></i> In </b-button>
      </b-col>
      <b-col sm="12" md="4">
        <b-button :disabled="receipt.id != ''" block variant="success" @click="doSave">
          <i class="fa fa-save" aria-hidden="true"></i>
          {{ receipt.id != '' ? 'Đã lưu báo giá' : 'Lưu Báo giá' }}
        </b-button>
      </b-col>
    </b-row>
    <block ref="bmdal" :nobody="true">
      <div id="print-xuat" class="print-box mt-3 mb-3" style="padding-top:25px">
        <div class="header text-center">
          <h3>CÔNG TY TNHH ĐAI MI VN</h3>
          ADD : 66/2 Đường LK 2-5, P.Bình Trị Đông, TP.HCM <br />
          Tel: 028-66828806 Email: daimivn@gmail.com <br />

          <h3 style="margin-top:10px">PHIẾU XUẤT KHO</h3>

          <img
            src="https://daimi.vn/resource/images/logo.png"
            style="position: absolute; left: 0;top: 0;width: 100px;"
            srcset=""
          />
        </div>
        <div class="" style="margin-top:0px">
          <table class="prtable">
            <tr>
              <td colspan="2">
                Mã PO : <span v-if="receipt && receipt.order">{{ receipt.order.poCode }}</span>
                <span v-else>{{ receipt.poCode }}</span>
              </td>
            </tr>
            <tr>
              <td>
                <div style="white-space: nowrap;">Ngày. tháng : {{ $date(receipt.date) }}</div>
                <div style="white-space: nowrap;">
                  Công ty nhận hàng:
                  <b v-if="receipt.receiver">{{ receipt.receiver.short_name }}</b>
                </div>
                <div style="white-space: nowrap;">
                  Địa chỉ nhận hàng :
                  <span v-if="receipt.receiverContact">
                    {{ receipt.receiverContact.address }}
                  </span>
                </div>
              </td>
              <td style="text-align: end;">
                <div style="white-space: nowrap;">Mã phiếu : {{ receipt.code }}</div>
                <div style="white-space: nowrap;">
                  Đơn vị:
                  <b v-if="receipt.customer">{{ receipt.customer.short_name }}</b>
                </div>
                <div style="white-space: nowrap;">
                  Mã khách hàng: <b>{{ receipt.customer.code }}</b>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="data">
          <table class="prtable prtable-bordered">
            <thead>
              <tr style="border-top:1px solid;border-bottom:1px solid;">
                <th style="width:1px;font-size:10px; padding:0px 5px; text-align:center">
                  STT
                </th>
                <th style="min-width:100px;font-size:10px; padding:0px 5px">
                  Tên sản phẩm
                </th>
                <th style="min-width:60px;font-size:10px; padding:0px 5px; text-align:center">
                  Mã SP
                </th>
                <th style="width:100px;font-size:10px; padding:0px 5px ; text-align:center">
                  Màu
                </th>

                <th style="width:56px;font-size:10px; padding:0px 5px; text-align:center">
                  Quy cách
                </th>
                <th style="width:55px;font-size:10px; padding:0px 5px ; text-align:center">
                  Độ dài
                </th>
                <th style="font-size:10px; padding:0px 5px; width:55px; text-align:center">
                  S/Lượng
                </th>
                <th style="font-size:10px; padding:5px 5px; text-align:center">
                  ĐVT
                </th>
                <th style="font-size:10px; padding:0px 5px; min-width:70px">
                  Ghi chú
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in productReceipts" :key="index">
                <td style=" text-align:center">{{ index + 1 }}</td>
                <td v-if="!item.hiden" :rowspan="item.rowSpan">
                  {{ item.product.name }}
                  <!-- <span v-if="item.productCustom !=''"><br/>{{ item.productCustom }}</span> -->
                  <span v-if="item.reason"><br />{{ item.reason.name }}</span>
                </td>
                <td style="text-align:center" v-if="!item.hiden" :rowspan="item.rowSpan">
                  {{ item.product.code }} <br />
                </td>
                <td style="text-align:center">
                  <span style="white-space: nowrap;">{{ item.colorText }}</span> <br />
                  <span style="white-space: nowrap;">{{ item.colorCode1 }}</span>
                </td>
                <td style="text-align:center">{{ item.productSpecify.name }}mm</td>
                <td style="text-align:center">{{ item.length }} cm</td>
                <td style="text-align:right; padding:auto 5px;">
                  {{ $formatNumber(item.quantity) }}
                </td>
                <td style="text-align:center">{{ $ucWord(item.unit) }}</td>
                <td>
                  <div v-html="item.note" class="d-block" style="white-space: nowrap;"></div>
                  <span>{{ item.poCode }}</span>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td style="text-align:right; padding: 10px; border-right: none" colspan="6">
                  Tổng cộng
                </td>
                <td style="text-align:right;padding: 10px; border: none">
                  {{ $formatNumber(summary.quantity) }}
                </td>
                <td style="text-align:center;padding: 10px 0; border: none">
                  {{ $ucWord(summary.unit) }}
                </td>
                <td style="text-align:center;padding: 10px 0;border-left: none">
                  <span v-if="receipt.package" style="white-space: nowrap;"> = {{ receipt.package }} </span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="footer">
          <table class="prtable">
            <tr>
              <td colspan="2">
                <div v-html="receipt.note"></div>
              </td>
            </tr>
            <tr>
              <td colspan="3" style="border-top:1px solid; font-size:10px">
                Ghi chú : Khi tiền hàng chưa thanh toán hết, thì hàng vẫn thuộc sở hữu của Cty DAI MI, khi nhận hàng nếu
                hàng có vấn đề phải khiếu nại với Cty DAI MI trong vòng 10 ngày .
              </td>
            </tr>
            <tr>
              <td><br /></td>
            </tr>
            <tr>
              <td class="text-center">Người nhận hàng</td>
              <td class="text-center">Người lập biểu</td>
              <td class="text-center">
                Thủ kho
              </td>
            </tr>
            <tr>
              <td><br /><br /><br /></td>
            </tr>
          </table>
        </div>
      </div>
      <event @doCancel="handleClose"></event>
    </block>
  </modal>
</template>
<script>
import { capitalize } from '@/utils/string';
export default {
  props: {},
  data() {
    return {
      visible: false,
      receipt: {
        id: '',
        type: 'in',
        customer: {}
      },
      summary: { quantity: 0, unit: 'M' },
      productReceipts: {}
    };
  },
  methods: {
    setData(receipt, productReceipts) {
      this.receipt = receipt;

      // productReceipts.sort((a, b) => {
      //   if (a.product.name < b.product.name) {
      //     return -1;
      //   }
      //   if (a.product.name > b.product.name) {
      //     return 1;
      //   }
      //   return 0;
      // });
      // productReceipts.sort((a, b) => {
      //   if (a.spec.name > b.spec.name) {
      //     return -1;
      //   }
      //   if (a.spec.name < b.spec.name) {
      //     return 1;
      //   }
      //   return 0;
      // });
      productReceipts.sort((a, b) => {
        if (a.product.name < b.product.name) {
          return -1;
        }
        if (a.product.name > b.product.name) {
          return 1;
        } else {
          if (Number(a.productSpecify.name) > Number(b.productSpecify.name)) {
            return 1;
          }
          if (Number(a.productSpecify.name) < Number(b.productSpecify.name)) {
            return -1;
          }
          return 0;
        }
      });
      this.summary = {
        quantity: 0,
        unit: 'M'
      };
      for (let i = 0; i < productReceipts.length; i++) {
        let item = productReceipts[i];
        this.summary.quantity += item.quantity;
        this.summary.unit = item.unit;
        // item.rowSpan = this.checkSameRow(productReceipts, i, (a, b) => {
        //   return a.productSpecify.name == b.productSpecify.name && a.product.code == b.product.code;
        // });
      }
      console.log('xxxx', productReceipts);
      this.productReceipts = productReceipts;
    },
    checkSameRow(datas, index, compareX, count = 1) {
      let nextIndex = index + 1;
      if (nextIndex >= datas.length) return 1;
      let item = datas[index];
      let nextItem = datas[nextIndex];
      if (compareX(item, nextItem)) {
        count++;
        nextItem.hiden = true;
        return 1 + this.checkSameRow(datas, nextIndex, compareX, count);
      }
      return 1;
    },
    handleClose() {
      this.visible = false;
    },
    doPrint() {
      this.$print('print-xuat');
    },
    doSave() {
      this.$refs.bmdal.block();
      this.$emit('doSave', () => {
        this.receipt.id = true;
        this.$refs.bmdal.unBlock();
      });
    },
    capitalize(s) {
      return capitalize(s);
    }
  }
};
</script>
